(function () {
  'use strict';

  angular.module('ringbaPortal').component('publisherCampaignNumbers', {
    bindings: {
      isAffiliateManager: '<',
      managerInReadOnlyGroup: '<',
      currentCampaign: '<',
      campaignCountry: '<',
      numberRestrictions: '<',
      isEnrolledInOffer: '<',
      onUpdate: '&'
    },
    controller: AddNumberController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/publisher-campaign-numbers/publisher-campaign-numbers.view.html'
  });

  function AddNumberController(
    $filter,
    $q,
    $scope,
    $uibModal,
    accountsService,
    isMobileDevice,
    numberService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.publisherNumbers = [];
    vm.inlinePayoutsItemsLimit = 3;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onCreate = onCreate;
    vm.showNumberForm = showNumberForm;
    vm.confirmDelete = confirmDelete;
    vm.cancelModal = cancelModal;
    vm.hideNumberForm = hideNumberForm;
    vm.confirmNumberDeleteModal = confirmNumberDeleteModal;
    vm.onUpdateNumber = onUpdateNumber;
    vm.scrollToCampaignPayoutWidget = scrollToCampaignPayoutWidget;
    vm.openDynamicInboundCallsDocumentationModal = openDynamicInboundCallsDocumentationModal; 
    vm.closeDynamicInboundCallsDocumentationModal = closeDynamicInboundCallsDocumentationModal; 

    function onInit() {
      vm.isMobileView = isMobileDevice;
      
      // If manager is in read-only group, they shouldn't update numbers regardless of other permissions
      if (vm.isAffiliateManager && vm.managerInReadOnlyGroup) {
        vm.canUpdateNumbers = false;
        vm.canManagerUpdateNumbers = false;
      } else {
        vm.canUpdateNumbers = vm.isEnrolledInOffer || accountsService.hasAccess('Number', 'UPDATE');
        vm.canManagerUpdateNumbers = vm.isAffiliateManager && !vm.managerInReadOnlyGroup;
      }

    }
            
    function onChanges(changesObj) {
      if (changesObj.currentCampaign && vm.currentCampaign) {
        if (vm.currentCampaign.affiliates) {
          vm.currentPublisher = vm.currentCampaign.affiliates[0];
        }

        vm.affiliatesPayoutMap = _setAffiliatePayoutSettings(vm.currentCampaign.affiliates);
        
        // Index affiliate numbers by affiliate ID for efficient lookup
        const numbersByAffiliateId = {};
        (vm.currentCampaign.affiliateNumbers || []).forEach(function(affiliateNumber) {
          if (!numbersByAffiliateId[affiliateNumber.affiliate.id]) {
            numbersByAffiliateId[affiliateNumber.affiliate.id] = [];
          }
          numbersByAffiliateId[affiliateNumber.affiliate.id].push(affiliateNumber);
        });
        
        // Build publisher numbers list by iterating through affiliates and merging associated numbers
        vm.publisherNumbers = [];
        (vm.currentCampaign.affiliates || []).forEach(function(affiliate) {
          const affiliateNumbers = numbersByAffiliateId[affiliate.id] || [];
          
          if (affiliateNumbers.length > 0) {
            // Append each number with enhanced metadata
            affiliateNumbers.forEach(function(affiliateNumber, index) {
              vm.publisherNumbers.push(Object.assign({}, affiliateNumber, {
                displayId: affiliate.id + '-' + index,
                payoutSettings: vm.affiliatesPayoutMap[affiliate.id],
                hasNoNumber: false
              }));
            });
          } else if (vm.isAffiliateManager) {
            // Create placeholder entry for affiliates lacking assigned numbers
            vm.publisherNumbers.push({
              id: null,
              displayId: affiliate.id,
              affiliate: affiliate,
              phoneNumber: null,
              localNumber: null,
              payoutSettings: vm.affiliatesPayoutMap[affiliate.id],
              hasNoNumber: true
            });
          }
        });

        _setPublisherNumbersRestrictionsForPublisherUser(vm.publisherNumbers);
      }

      if (changesObj.numberRestrictions) {
        _setPublisherNumbersRestrictionsForPublisherUser(vm.publisherNumbers);
      }
    }

    function scrollToCampaignPayoutWidget() {
      utils.scrollToElementId('panel-payout-settings', 60);
    }

    function showNumberForm(number) {
      if (!vm.formActive && (number || !number && !vm.disableAddNumbers)) {
        if (!number && !vm.disableAddNumbers) {
          vm.showAddNewForm = true;
        } else {
          vm.activeActionNumberId = false;
          number.showNumberForm = true;
        }
        vm.formActive = true;
      }
    }

    function hideNumberForm(number) {
      if (!number) {
        vm.showAddNewForm = false;
      } else {
        delete number.showNumberForm;
      }
      vm.formActive = false;
    }

    function onCreate() {
      hideNumberForm();
      vm.onUpdate();
    }

    function confirmNumberDeleteModal(number) {
      if (!vm.formActive) {
        if (vm.isEnrolledInOffer) {
          vm.numberForDelete = number;
          _showNumberDeleteConfirmationModal();
          return $q.when({});
        } else {
          return removePublisherNumber(number);
        }
      }
    }

    function removePublisherNumber(number) {
      return numberService.removeAffiliate(accountsService.currentAccountId, number.id, vm.currentPublisher.id).then(function () {
        toaster.pop('success', $filter('translate')('PUBLISHERS_NUMBERS_REMOVE_CAMPAIGN'));
        vm.onUpdate();
      }).catch(utils.errorHandler);
    }

    function confirmDelete() {
      return numberService.deleteNumber(accountsService.currentAccountId, vm.numberForDelete.id, true).then(function () {
        toaster.pop('success', 'The number has been deleted successfully');
        vm.onUpdate();
        cancelModal();
      }).catch(utils.errorHandler);
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.numberForDelete = null;
      }
    }

    function onUpdateNumber(number) {
      hideNumberForm(number);
      vm.onUpdate();
    }

    function _setAffiliatePayoutSettings(affiliates) {
      return affiliates.reduce(function (affiliatesMap, affiliate) {
        affiliatesMap[affiliate.id] = {
          payoutsOverridden: _getPayoutOverridden(affiliate.payoutConversionSettings, vm.currentCampaign),
          payoutSettingsList: affiliate.payoutConversionSettings
        };

        return affiliatesMap;
      }, {});
    }

    function _getPayoutOverridden(affiliatePayoutSettings, campaign) {
      if (affiliatePayoutSettings && affiliatePayoutSettings.length) {
        return 'overridden';
      } else if (campaign.defaultPayouts && campaign.defaultPayouts.length) {
        return 'campaign';
      } else {
        return 'none';
      }
    }

    function _setPublisherNumbersRestrictionsForPublisherUser(publisherNumbers) {
      if (vm.numberRestrictions && publisherNumbers && vm.isEnrolledInOffer) {
        vm.disableAddNumbers = publisherNumbers.length >= vm.numberRestrictions.maxNumbersPerPublisher;
        vm.offerNumAvailable = Math.max(vm.numberRestrictions.maxNumbersPerPublisher - vm.publisherNumbers.length, 0);
      } else {
        vm.disableAddNumbers = false;
      }
    }

    function _showNumberDeleteConfirmationModal() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/publisher-campaign-numbers/delete-publisher-number.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }
    
    function openDynamicInboundCallsDocumentationModal(affiliate) {
      if (vm.isAffiliateManager && affiliate && affiliate.rtbId) {
        affiliate.showDynamicInboundCallsDocumentationModal = true;
      } else {
        toaster.pop('warning', $filter('translate')('PUBLISHER_RTB_INFO_NOT_AVAILABLE'));
      }
    }

    function closeDynamicInboundCallsDocumentationModal(affiliate) {
      if (affiliate) {
        affiliate.showDynamicInboundCallsDocumentationModal = false;
      }
    }

  }
})();
